import { CountryCode, isValidNumber, NationalNumber, format, parseNumber, ParsedNumber } from 'libphonenumber-js';
import { ValidationErrors } from '@angular/forms';

export const DEFAULT_COUNTRY_CODE: CountryCode = 'US';

export interface PhoneFields {
  nationalNumber: NationalNumber;
  isoCountryCode: CountryCode;
  extension?: string;
}

export const parsePhoneNumber = (phoneValue: string): PhoneFields => {
  const parsedNumber = parseNumber(phoneValue, {
    defaultCountry: DEFAULT_COUNTRY_CODE,
  }) as ParsedNumber;
  return {
    nationalNumber: parsedNumber.phone,
    isoCountryCode: parsedNumber.country,
    extension: parsedNumber.ext,
  };
};

export const formatAsRFC3966Phone = (parsedNumber: PhoneFields): string => {
  if (!parsedNumber.nationalNumber) {
    return '';
  }
  const parsed = {
    country: parsedNumber.isoCountryCode,
    phone: parsedNumber.nationalNumber,
    ext: parsedNumber.extension,
  } as ParsedNumber;
  return format(parsed, 'RFC3966');
};

export const validatePhone = (phone: NationalNumber, country: CountryCode): ValidationErrors | null => {
  let isInvalid = true;
  try {
    isInvalid = !isValidNumber(phone, country);
  } catch (e) {
    console.warn('Error validating phone number', phone, 'with country code', country, e);
  }

  if (isInvalid) {
    return {
      invalidPhoneNumber: true,
    };
  }
  
  const cannotParse = !Object.keys(
    parsePhoneNumber(formatAsRFC3966Phone({ nationalNumber: phone, isoCountryCode: country })),
  ).length;
  
  if (cannotParse) {
    return {
      invalidPhoneNumber: true,
    };
  }
  
  return null;
};

